/* epi-promo-drawer.js — Promo banner click → side drawer */
(function () {
  'use strict';

  const drawer = document.getElementById('epi-promo-drawer');
  const backdrop = document.getElementById('epi-promo-backdrop');
  if (!drawer) return;

  function open() {
    drawer.classList.add('is-open');
    if (backdrop) backdrop.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    drawer.querySelector('[data-promo-close]').focus();
  }

  function close() {
    drawer.classList.remove('is-open');
    if (backdrop) backdrop.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-promo-trigger]')) open();
  });

  drawer.addEventListener('click', function (e) {
    if (e.target.closest('[data-promo-close]')) close();
  });

  if (backdrop) backdrop.addEventListener('click', close);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
  });
})();
